import { Circle } from "@phosphor-icons/react"
import classNames from "classnames"

export const Status = ({ status }: { status: string }) => {
  return (
    <div
      className={classNames(
        "flex gap-1 items-center ",
        status === "created"
          ? "text-blue"
          : status === "closed"
          ? "text-red"
          : status === "uploading_enquiries"
          ? "text-yellow-400"
          : "text-green"
      )}
    >
      <Circle weight="fill" />
      {status === "created"
        ? "Created"
        : status === "closed"
        ? "Closed"
        : status === "uploading_enquiries"
        ? "Uploading Enquiries"
        : "Live"}
    </div>
  )
}
